import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currentLanguage: ''
}

export const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        setLanguage: (state, action:  any) => ({
            ...state,
            currentLanguage: action.payload
        })
    }
})
export const {setLanguage} = languageSlice.actions;
const {reducer: languageReducer } = languageSlice;
export default languageReducer;